import { render } from "./ModModifiElimAct.vue?vue&type=template&id=80d48fce"
import script from "./ModModifiElimAct.vue?vue&type=script&lang=js"
export * from "./ModModifiElimAct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__